import React from 'react';

type Props = {
  children: React.ReactNode;
  groupClasses?: string;
}

const FormGroupWrapper = (props: Props) => {
  const { children, groupClasses } = props;
  let wrapperClass = 'form-group';
  if (groupClasses) {
    wrapperClass += ` ${groupClasses}`;
  }

  return (
    <div className={wrapperClass}>
      {children}
    </div>
  );
};

export default FormGroupWrapper;
